<template>
  <el-dialog width="520px"  title="修改密码" :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="editPasswordVisible">
    <div class="details" v-loading="loading">
      <div >
        <el-form    size="small" ref="currencyForm"   v-loading="loading"    label-position="right"   label-width="80px"  :model="currencyForm"  :rules="currencyFormRules">

          <el-form-item label="密码" prop="password" >
            <el-input type="text" v-model="currencyForm.password" placeholder="请输入密码"></el-input>
          </el-form-item>

        </el-form>
      </div>
    </div>
    <div slot="footer">
      <el-button size="small"  :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button  size="small" type="primary"  :disabled="BtnDisabled" @click="handleClickConfirm">确认</el-button>
    </div>

    <el-dialog title="修改头像" :visible.sync="editAvatarDialog" width="50%" append-to-body :close-on-click-modal="false">
      <Cropper :Avatarfile="Avatarfile" :editAvatarDialog.sync="editAvatarDialog" @change="getCropper"
               v-if="editAvatarDialog"/>
    </el-dialog>
  </el-dialog>
</template>
<script>

import {adminPersonalEdit} from '@/api/api'
import {mapState} from "vuex";
export default {
  name: 'admin_edit_password',
  props: {
    editPasswordVisible: {
      type: Boolean,
      default: false,
    },
  },
  components: {

  },
  data() {
    return {
      loading:false,
      BtnDisabled: false,
      currencyForm:{
        password:'',
      },
      currencyFormRules:{
        password:[{ required: true, message: '请输入密码', trigger: 'blur'}],
      },
    }
  },

  created() {
  },
  computed: {
    ...mapState(['webUserInfo']),
  },
  mounted() {

  },
  methods: {
    handleClickConfirm(){
      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          let postData = {
            password:this.currencyForm.password,
          }
          this.BtnDisabled = true
          adminPersonalEdit(postData).then(res => {
            if (res.code === 200) {
              this.$message({
                message:'修改成功',
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.BtnDisabled = false
                  this.$emit('success')
                  this.$emit('update:editPasswordVisible', false)
                }
              })
            }else{
              this.BtnDisabled = false
            }
          }).catch((e) => {
            this.BtnDisabled = false
          })
        }
      })
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:editPasswordVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}
</style>
